window.addEventListener('DOMContentLoaded', () =>{
    let headerLogoElement = document.querySelector('#header-sticky-menu .top-section');
    let headerHidden = false;

    window.addEventListener('scroll', () => {
        let headerSize = document.getElementById('header-sticky-menu').getBoundingClientRect();
        if( headerSize.height < document.documentElement.scrollTop ){
            if( !headerHidden ){
                headerLogoElement.classList.add('moved');
                headerHidden = true;
            }
        } else {
            if( headerHidden ){
                headerLogoElement.classList.remove('moved');
                headerHidden = false;
            }
        }

    });

    window.addEventListener('resize', () => {
        if( window.innerWidth > 991 ){
            document.body.querySelector('#container-phone-menu').classList.remove('open');
            //document.body.querySelector('#container-phone-user-menu').classList.remove('open');
        }
        if( window.innerWidth < 991 && !window.menu ){
            menuControler();
        }
    });

    if( window.innerWidth < 991 ){
        menuControler();
    }

    let nodes = document.body.querySelectorAll('.action-click');

    for( let i=0 ; i < nodes.length; i++ ){
        let node = nodes[i];
        node.addEventListener('click', ( e ) => {
            e.stopPropagation();
            
            if( e.currentTarget.getAttribute('action') == 'toggleClass' ){
                let targetNode = document.querySelector( e.currentTarget.getAttribute('action-target') );
                let value = e.currentTarget.getAttribute('action-value');
                if( !targetNode.classList.toggle( value )){
                    document.getElementById('menu-top-holder-phone').style.left="0";    
                }
            }

        })
    }



    function menuControler(){
        
        window.menu = true;
        let elemMenu = document.getElementById('menu-top-holder-phone');
        let elemMenuLists = elemMenu.querySelectorAll('ul.sub-menu');
        
        for( let i=0 ; i < elemMenuLists.length; i++){

            let li = document.createElement("li");
            li.innerHTML = '<span class="back-button"><i class="fas fa-chevron-circle-left"></i> TERUG</span>';
            li.className = 'menu-back-element';
            elemMenuLists[i].prepend( li );
            li.addEventListener('click', ( e ) => {
                e.preventDefault();
                e.stopPropagation();
                let parentsCount = 0;
                let parent = li;
                while( parent.parentNode && ( parent.parentNode.nodeName == "LI" || parent.parentNode.nodeName == "UL") ){
                    if( parent.parentNode.nodeName == "UL" )
                        parentsCount++;
                    parent = parent.parentNode;
                }
                elemMenu.style.left = '-' + ( (parentsCount-2) * 100) +'%';

            });

        }

        let a = elemMenu.querySelectorAll('a');

        function listenerClick( e ){
            e.stopPropagation();

            if( window.innerWidth < 991 ){
                let nextMenu =  e.target.parentNode.querySelector( 'ul' );

                let parentsCount = 0;
                let parent = nextMenu;
                while( parent.parentNode && ( parent.parentNode.nodeName == "LI" || parent.parentNode.nodeName == "UL") ){
                    if( parent.parentNode.nodeName == "UL" )
                        parentsCount++;
                    parent = parent.parentNode;
                }

                if( nextMenu ){
                    e.preventDefault();
                    elemMenu.style.left = '-' + (parentsCount * 100) +'%';
                }else {

                }
            }
            
        };

        for( let i=0 ; i < a.length; i++){
            a[i].addEventListener( 'click', listenerClick );
        }

    }

    var filterButton = document.getElementById('filter-by');
    if( filterButton ){
        filterButton.addEventListener('click', function(){
            filterController()
        });
    }
    function filterController(){
        filterContent = '';
    }

    let modalSidebars = document.querySelectorAll('.modal-sidebar');
    [...modalSidebars].map( ( elem ) => {
        let opener = elem.querySelector('.modal-open');
        opener.addEventListener('click', () => {
            elem.querySelector('.dashicons-no').addEventListener('click', ( e ) => {
                e.stopPropagation();
                elem.querySelector('.modal-sidebar-content').classList.remove('open');
            });
            elem.querySelector('.modal-sidebar-content').classList.add('open');
        });
    });

    var elms = document.querySelectorAll( '.splide.simple' );
    for ( var i = 0, len = elms.length; i < len; i++ ) {
        new Splide( elms[ i ],{
            perPage: 5,
            perMove: 1,
            gap:40,
            type: 'loop',
                padding: {
                right: '5rem',
                left : '5rem',
            },
            breakpoints: {
            767: {
                perPage: 1,
                gap:20,
                padding: {
                    right: '2rem',
                    left : '2rem',
                },
            },
        }
        }).mount();
    }

    var elms = document.querySelectorAll( '.splidegallery' );
    for ( var i = 0, len = elms.length; i < len; i++ ) {
        new Splide( elms[ i ],{
            perPage: 1,
            perMove: 1,
            type: 'loop',
            destroy: true,
            breakpoints: {
            991: {
                perPage: 1,
                gap:20,
          
            },
        }
        }).mount();
    }

    var elms = document.getElementsByClassName( 'splide-excerpt' );
    for ( var i = 0, len = elms.length; i < len; i++ ) {
        new Splide( elms[ i ],{
            perPage: 3,
            perMove: 1,
            gap:20,
            type: 'loop',
            breakpoints: {
                767: {
                    perPage: 1,
                    gap:20,
                    padding: {
                        right: '5rem',
                        left : '5rem',
                    },
                },
            }
         
                
        }).mount();
    }

    [...document.querySelectorAll('.item-slider')].forEach( slider => {
        
        jQuery(slider.querySelector('.shop-categories-slider')).slick({
            infinite: false,
            swipeToSlide:true, 
            variableWidth: true,
            prevArrow:slider.querySelector('.slick-prev'),
            nextArrow:slider.querySelector('.slick-next'),
        });
    });
});